import { Component, ContentChild, ContentChildren, Directive, EventEmitter, Input, OnInit, TemplateRef } from '@angular/core';
import { ButtonList } from '../actions-buttons/actions-buttons.component';
import { animate, group, state, style, transition, trigger } from '@angular/animations';



export interface StepDataInterface{
      sideDesc:string;
      name:string;
      title:string;
      info?:string;
      buttonList?:ButtonList[];
      state?:string;
      showCondition?:()=>boolean;
     
}


@Component({
    selector: 'side-panel',
    templateUrl: './side-panel.component.html',
    styleUrl: './side-panel.component.scss',
    animations: [
        trigger('slideInOut', [
            state('in', style({ transform: 'translateY(0%)' })),
            state('out', style({ transform: 'translateY(0%)' })),
            transition('out=>*', [group([
                    /*animate('700ms ease-in-out', style({
                        'visibility': 'hidden'
                    })),
                  
                    animate('600ms ease-in-out', style({
                        'max-height': '0px'
                    })),
                    animate('400ms ease-in-out', style({
                        'opacity': '0'
                    }))*/
                    //style({transform: ''}),
                    animate('1000ms', style({ transform: 'translateY(0%)' }))
                ])])
        ]),
        trigger('tabMovement', [
            state('up', style({ transform: 'translateY(0%)' })),
            state('down', style({ transform: 'translateY(0%)' })),
            transition('*<=>*', [style({ transform: 'translateY({{offset}}%)' }), animate('0.5s')])
        ])
    ],
    standalone: false
})


export class SidePanelComponent implements OnInit{
  
  selectionChange:EventEmitter<number> = new EventEmitter();
  animationState = 'in';

  ngOnInit(): void {
    if ( this.stepData.length > 0 ){
      this.selectedName = this.stepData[0].name;
    }  
    
  }

  ngAfterViewInit(){
    
  }

  @ContentChild('contentSidePanel') contentTemplateRef: TemplateRef<any>;
  @Input() stepData:StepDataInterface[] = [];
  selected = 1;
  selectedName  = 'none';
  typeSelection='down';
  multiplyer = 0;
  multiplyerBody = 100;

  selectTabName(name){
      
    const oldName = this.selectedName;
    const old = this.stepData.findIndex(d=>d['name']==oldName)+1;
    let id = this.stepData.findIndex(d=>d['name']==name)+1;
    this.selectedName = name;
    this.selected = id;
    this.selectionChange.emit(this.selected);  
    this.stepData.find(d=>d['name']==oldName).state = 'out'
    this.stepData.find(d=>d['name']==name).state = 'in'
    
    if ( old == id ){
      this.typeSelection = 'none';
    }      
    if ( old < id ){
      this.typeSelection = 'down'+this.selected;
      this.multiplyer = (old-id)*100;
      this.multiplyerBody= 100;
    }else{
      this.typeSelection = 'up'+this.selected;
      this.multiplyer = (old - id)*100;
      this.multiplyerBody= -100;
    }
  }
}
